import React from 'react';
import Filter from '../Filter';
import Paging from '../Paging';
import * as styles from './Rating.scss';
import RatingFirms from '../RatingFirms';
import Description from '../Description';
import RatingFirmsLoading from '../RatingFirmsLoading';
import RatingFirmsLoadingMobile from '../RatingFirmsLoadingMobile';
import RatingFirmsNotFound from '../RatingFirmsNotFound';
import {
  ActiveTransporterBanner, SafetyBanner, ReadyForEtrnBanner, AvgPriceBanner,
} from '../Banners';
import RatingTabs from '../RatingTabs';

const Rating = (props) => {
  const {
    firms,
    totalFirmsCount,
    rowsCount,
    resetFilterAction,
    selectedRow,
    showPaging,
    isFound,
    isNotFound,
    isRatingLoading,
    showActiveTransporterBanner,
    showSafetyBanner,
    showReadyForEtrnBanner,
    showAvgPriceBanner,
    isMobile,
  } = props;

  const RatingLoadingComponent = isMobile ? RatingFirmsLoadingMobile : RatingFirmsLoading;

  return (
    <div className={styles.rating}>
      <Description isMobile={isMobile} />
      {!isMobile && <RatingTabs /> }
      <Filter />
      { showActiveTransporterBanner &&
        <ActiveTransporterBanner />
      }
      { showSafetyBanner &&
        <SafetyBanner />
      }
      { showReadyForEtrnBanner &&
        <ReadyForEtrnBanner />
      }
      { showAvgPriceBanner &&
        <AvgPriceBanner />
      }
      { isFound &&
        <RatingFirms
          firms={firms}
          totalFirmsCount={totalFirmsCount}
          selectedRow={selectedRow}
          isMobile={isMobile}
        />
      }
      { isNotFound &&
        <RatingFirmsNotFound onResetFiltersAction={resetFilterAction} />
      }
      { isRatingLoading &&
        <RatingLoadingComponent rowsCount={rowsCount} />
      }
      { showPaging &&
        <Paging />
      }
    </div>
  );
};

export default Rating;
